/**
 * ReplyBulletRenderer — a BlockBulletRenderer for isReply blocks
 *
 * Extracts the bullet icon customization that is currently hardcoded
 * in BulletMenu.tsx (line 281):
 *
 *   block.isReply && hasKids() && 'rotate-180'
 *
 * Demonstrates how to move per-block bullet customizations into a
 * dedicated plugin. When registered, this renderer matches any block
 * that is a reply with children and adds a 180° rotation class to
 * the bullet icon.
 */

import type { BlockBulletRenderer } from '../types'

export const pluginReplyBullet: BlockBulletRenderer = {
  name: 'reply-bullet',
  priority: 10,

  /** Match blocks that are replies AND have children */
  matches: (ctx) => ctx.block.isReply && ctx.hasKids,

  /** Rotate the bullet icon 180° for reply blocks with kids */
  getBulletProps: () => ({
    class: 'rotate-180',
  }),
}
